<template>
    <h1 class="page-title">Liste des fournisseurs</h1>
    <div class="flex justify-end">
        <Button
            label="Ajouter un fournisseur"
            @click="setUuidAndOpenModal('')"
            icon="pi pi-plus"
            aria-label="Ajouter un fournisseur"
            class="button-add" />
    </div>
    
    
    <div class="card">
        <DataTable lazy dataKey="uuid"
            stateStorage="local"
            ref="dt"
            :state-key="localStorageKey"
            :value="tableData"
            :paginator="true"
            :rows="rows"
            :rowHover="true"
            sortMode="multiple"
            removableSort
            v-model:selection="selectedSuppliers"
            :metaKeySelection="false"
            :loading="isLoading"
            :totalRecords="totalRecords"
            :currentPage="currentPage"
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            :rowsPerPageOptions="rowsPerPageOptions"
            currentPageReportTemplate="Affichage de {first} à {last} sur {totalRecords} entrées"
            :selectAll="selectAll"
            @select-all-change="onRowSelectAll()"
            @row-select="onRowSelect()"
            @row-unselect="onRowUnselect()"
            @page="onPaginate($event)"
            @sort="onSort($event)">
            <template #loading> Chargement... </template>
            <template #header>
                <div class="flex w-full">
                    <div class="flex card-toolbar w-full">
                        <div class="w-full">
                            <span class="p-input-icon-left w-10/12">
                                <i class="pi pi-search" />
                                <InputText type="text" class="w-64" v-model="criteria"
                                    placeholder="Recherche par fournisseur" @input="onSearchInputDt()" />
                            </span>
                        </div>
                    </div>                   
                   
                    <div class=" justify-end ml-auto ">                             
                        <select v-model="selectedGroupAction" class=" bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                            <option selected value="">Actions</option>
                            <option :value="enableGroupAction">Activer</option>
                            <option :value="disableGroupAction">Désactiver</option>
                        </select>
                    </div>
                </div>

                <div class="flex w-full mt-6">
                    <div class=" ml-auto justify-end">
                        <p>Nombre total de fournisseurs : {{ totalRecords }}</p>
                        <p>
                            Nombre de ligne sélectionnée(s) : {{ totalSelectedSuppliers }} 
                        </p>
                        <p v-if:="isInFilteredView">Vous êtes en vue filtrée</p>
                    </div>
                </div>
            </template>
            <div class="card-body pt-0">
                <Column selectionMode="multiple"></Column>
                <Column field="name" header="Fournisseur">
                    <template #body="slotProps">
                      <span> {{ slotProps.data.name }}</span>
                    </template>
                </Column>
                <Column field="fees" header="Frais de gestion">
                    <template #body="slotProps">
                        <div v-if="slotProps.data.fees != null">
                            {{ slotProps.data.fees }}
                        </div>
                        <div v-else>Non</div>
                    </template>
                </Column>
                <Column field="createdAt" header="Date de création" sortable>
                    <template #body="slotProps">
                        <span> {{ slotProps.data.createdAt }} </span>
                    </template>
                </Column>
                <Column field="createdBy" header="Créé par" sortable>
                    <template #body="slotProps">
                        <span> {{ slotProps.data.createdBy }} </span>
                    </template>
                </Column>
                <Column field="isActive" header="État" sortable>
                    <template #body="slotProps">
                        <div v-if="slotProps.data.isActive" 
                            class="text-center bg-green-100 text-green-800 text-xs font-medium mr-2 px-2.5 py-0.5 rounded-full dark:bg-green-900 dark:text-green-300">
                            Actif
                        </div>
                        <div v-else 
                            class="text-center bg-red-100 text-red-800 text-xs font-medium mr-2 px-2.5 py-0.5 rounded-full dark:bg-red-900 dark:text-red-300">
                            Inactif
                        </div>
                    </template>
                </Column>
                <Column headerStyle="width: 12em;">
                    <template #header>
                        <div>Actions</div>
                    </template>
                    <template #body="slotProps">
                      <Button size="small" icon="pi pi-eye" class="p-button-eye"
                              :class="`${slotProps.data.uuid}`"
                              style="margin-right: 0.5em" title="Voir" @click="router.push({ name: 'supplierDetail', params: { uuid: slotProps.data.uuid } })">
                        
                      </Button>
                        <Button size="small" icon="pi pi-pencil" class="p-edition" 
                            :class="`${slotProps.data.uuid}`"
                            style="margin-right: 0.5em" title="Éditer" @click="setUuidAndOpenModal(slotProps.data.uuid)">
                        </Button>
                        
                        <InputSwitch v-model="slotProps.data.isActive" :input-id="slotProps.data.uuid" @input="
                            checkSuppliersStatus(
                                slotProps.data.isActive ? enableOneAction : disableOneAction,
                                slotProps.data.isActive
                                    ? `Êtes-vous sûr de vouloir activer le fournisseur et produits associés ?`
                                    : `Êtes-vous sûr de vouloir désactiver le fournisseur et produits associés ?`,
                                slotProps.data.isActive
                                    ? `vous venez d'activer 1 fournisseur et les produits associés`
                                    : `vous venez de désactiver 1 fournisseur et les produits associés`,
                                `Annuler`,
                                slotProps.data.isActive ? `Oui, activer` : `Oui, désactiver`,
                                slotProps.data.isActive
                                    ? `btn btn-success`
                                    : `btn btn-danger`,
                                `btn btn-secondary`,
                                slotProps.data.uuid
                            )
                            " />
                    </template>
                </Column>
            </div>
            <template #empty>Aucun résultat trouvé.</template>
        </DataTable>
        <!-- begin::Supplier crud modal -->
        <SupplierFormModal :supplier-uuid="supplierUuid" :supplier-form-modal-id="supplierFormModalId"></SupplierFormModal>
        <!-- end::Supplier crud modal -->
    </div>
</template>

<script lang="ts" setup>
import { ref, onMounted, watch, onBeforeMount } from "vue";
import ApiService from "@/_services/api.service";
import swal from "@/_helpers/swal";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import InputSwitch from "primevue/inputswitch";
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import { fetchAllSuppliers, fetchSuppliers } from "@/_services/supplier/supplier";
import { ISortType } from "@/models/supplier/ISortType";
import { ISupplier } from "@/models/supplier/ISupplier";

const supplierFormModalId = "supplierFormModal";
const localStorageKey = "selectedSuppliers";
const isLoading = ref<boolean>(true);
const isInFilteredView = ref<boolean>(false);
const selectedGroupAction = ref<string>("");
const enableGroupAction = "enable-by-group";
const disableGroupAction = "disable-by-group";
const enableOneAction = "enable-one";
const disableOneAction = "disable-one";
const suppliers = Array<ISupplier>();
const tableData = ref<Array<ISupplier>>(suppliers);
const totalSelectedSuppliers = ref<number>(0);
const selectedSuppliers = ref(Array<ISupplier>());
const currentPage = ref<number>(0);
const rows = ref<number>(10);
const totalRecords = ref<number>(0);
const page = ref<number>(1);
const criteria = ref<string>("");
const isActiveUrlParam = ref<boolean | undefined>(undefined);
const sortFilterUrlParam = ref<Array<ISortType>>([]);
const defaultRowsPerPage = 10;
const rowsPerPageOptions = [defaultRowsPerPage, 25, 100];
const selectAll = ref(false);
import SupplierFormModal from "@/components/modal/supplier/SupplierFormModal.vue";
import router from "@/router";

onBeforeMount(() => {
    localStorage.removeItem(localStorageKey);
});

onMounted(async () => {
    totalSelectedSuppliers.value = selectedSuppliers.value.length;
    await populateDataTableWithLocalStorageFilters();
});

function onSearchInputDt() {
    let search = criteria.value.trim();
    showSpinner();
    populateDatatable(
        rows.value,
        page.value,
        "" != search ? search : "",
        sortFilterUrlParam.value,
        isActiveUrlParam.value
    );
}

const showSpinner = () => {
    isLoading.value = true;
}

const hideSpinner = () => {
    isLoading.value = false;
}

async function populateDatatable(
    itemsPerPage,
    page,
    criteria?,
    sort?: ISortType[] | undefined,
    isActive?: boolean | undefined
) {
    showSpinner();
    const [loadingDt, totalRecordsDt, tableDataDt] = await fetchSuppliers(
        itemsPerPage,
        page,
        criteria,
        sort,
        criteria !== "" ? criteria : undefined,
        isActive
    );
    totalRecords.value = totalRecordsDt.value;
    isLoading.value = loadingDt.value;
    tableData.value = tableDataDt.value;
}

async function populateDataTableWithLocalStorageFilters(
    itemsPerPage?: number,
    page?: number
) {
    let localStorageData = getLocalStorageData();
    if (null !== localStorageData) {
        let sortFilterFromLocalStorage = localStorageData.multiSortMeta;
        if (sortFilterFromLocalStorage.length <= 0) {
            setIsInFilteredView(false);
            isActiveUrlParam.value = undefined;
            sortFilterUrlParam.value = [];
        }

        if (sortFilterFromLocalStorage.length > 0) {
            setIsInFilteredView(true);
            sortFilterFromLocalStorage.forEach((item, index: number) => {
                if ("isActive" == item.field) {
                    isActiveUrlParam.value = [-1, 1].includes(item.order)
                        ? item.order === 1
                        : undefined;
                }
                if ("createdAt" == item.field) {
                    let isParamAlreadyExist = false;
                    let sort = item.order === 1 ? "asc" : "desc";
                    sortFilterUrlParam.value.forEach((param, index: number) => {
                        if ("order[createdAt]" == param.fieldLabel) {
                            isParamAlreadyExist = true;
                            param.fieldValue = sort;
                        }
                    });
                    if (!isParamAlreadyExist) {
                        sortFilterUrlParam.value.push({
                            fieldLabel: "order[createdAt]",
                            fieldValue: sort,
                        });
                    }
                }
                if ("createdBy" == item.field) {
                    let isParamAlreadyExist = false;
                    let sort = item.order === 1 ? "asc" : "desc";
                    sortFilterUrlParam.value.forEach((param, index: number) => {
                        if ("order[createdBy.firstname]" == param.fieldLabel) {
                            isParamAlreadyExist = true;
                            param.fieldValue = sort;
                        }
                    });
                    if (!isParamAlreadyExist) {
                        sortFilterUrlParam.value.push({
                            fieldLabel: "order[createdBy.firstname]",
                            fieldValue: sort,
                        });
                    }
                }
            });
        }
    }

    let localStorageRowPerPage = getLocalStorageRowsPerPage();
    let localStorageFisrtPageState = getLocalStorageFisrtPageState();
    let currentPage = page;
    if (!currentPage) {
        currentPage = localStorageFisrtPageState / localStorageRowPerPage + 1;
    }
    let currentItemsPerPage = itemsPerPage;
    if (!currentItemsPerPage) {
        currentItemsPerPage = localStorageRowPerPage;
    }

    populateDatatable(
        currentItemsPerPage,
        currentPage,
        criteria.value,
        sortFilterUrlParam.value,
        isActiveUrlParam.value
    );
}

function setIsInFilteredView(value: boolean) {
    isInFilteredView.value = value;
}

function onSort(e) {
    rows.value = e.rows;
    setLocalStorageRowsPerPage(rows.value);
    let sortFilter = e.multiSortMeta;
    if (sortFilter.length <= 0) {
        setIsInFilteredView(false);
        isActiveUrlParam.value = undefined;
        sortFilterUrlParam.value = [];
        populateDatatable(rows.value, page.value, criteria.value);
    }

    sortFilterUrlParam.value = [];
    if (sortFilter.length > 0) {
        setIsInFilteredView(true);
        sortFilter.forEach((item, index: number) => {
            if ("isActive" == item.field) {
                isActiveUrlParam.value = [-1, 1].includes(item.order)
                    ? item.order === 1
                    : undefined;
            }
            if ("createdAt" == item.field) {
                let isParamAlreadyExist = false;
                let sort = item.order === 1 ? "asc" : "desc";
                sortFilterUrlParam.value.forEach((param, index: number) => {
                    if ("order[createdAt]" == param.fieldLabel) {
                        isParamAlreadyExist = true;
                        param.fieldValue = sort;
                    }
                });
                if (!isParamAlreadyExist) {
                    sortFilterUrlParam.value.push({
                        fieldLabel: "order[createdAt]",
                        fieldValue: sort,
                    });
                }
            }
            if ("createdBy" == item.field) {
                let isParamAlreadyExist = false;
                let sort = item.order === 1 ? "asc" : "desc";
                sortFilterUrlParam.value.forEach((param, index: number) => {
                    if ("order[createdBy.firstname]" == param.fieldLabel) {
                        isParamAlreadyExist = true;
                        param.fieldValue = sort;
                    }
                });
                if (!isParamAlreadyExist) {
                    sortFilterUrlParam.value.push({
                        fieldLabel: "order[createdBy.firstname]",
                        fieldValue: sort,
                    });
                }
            }
        });

        populateDatatable(
            rows.value,
            page.value,
            criteria.value,
            sortFilterUrlParam.value,
            isActiveUrlParam.value
        );
    }
}

async function onPaginate(e) {
    showSpinner();
    rows.value = e.rows;
    page.value = e.page + 1;
    setLocalStorageRowsPerPage(rows.value);
    populateDataTableWithLocalStorageFilters(rows.value, page.value);
}

watch(selectedGroupAction, (newValue) => {
    if (enableGroupAction === newValue) {
        totalSelectedSuppliers.value <= 0
            ? swal.warning("Veuillez selectionner au moins un fournisseur")
            : checkSuppliersStatus(
                enableGroupAction,
                `Êtes-vous sûr de vouloir activer les (${totalSelectedSuppliers.value}) fournisseurs et produits associés ?`,
                `vous venez d'activer (${totalSelectedSuppliers.value}) fournisseurs et produits associés`,
                "Annuler",
                "Oui, activer",
                "btn btn-success",
                "btn btn-secondary"
            );
    }
    if (disableGroupAction === newValue) {
        totalSelectedSuppliers.value <= 0
            ? swal.warning("Veuillez selectionner au moins un fournisseur")
            : checkSuppliersStatus(
                disableGroupAction,
                `Êtes-vous sûr de vouloir désactiver les (${totalSelectedSuppliers.value}) fournisseurs et produits associés ?`,
                `vous venez de désactiver (${totalSelectedSuppliers.value}) fournisseurs et produits associés`,
                "Annuler",
                "Oui, désactiver",
                "btn btn-danger",
                "btn btn-secondary"
            );
    }
});



const onRowSelectAll = async () => {
    showSpinner();
    if(selectAll.value === false) {
        const [totalRecordsDt, tableDataDt] = 
            await fetchAllSuppliers();
        totalSelectedSuppliers.value = totalRecordsDt.value;
        totalRecords.value = totalRecordsDt.value;
        selectedSuppliers.value = tableDataDt.value;
        selectAll.value = true;
    } else {
        totalSelectedSuppliers.value = 0;
        selectAll.value = false;
        selectedSuppliers.value = [];
    }
    hideSpinner();
};

function onRowSelect() {
    totalSelectedSuppliers.value++;
}

function onRowUnselect() {
    totalSelectedSuppliers.value--;
}

function getLocalStorageData() {
    let storageData = localStorage.getItem(localStorageKey);
    
    if (null !== storageData && "undefined" !== storageData) {
        return JSON.parse(storageData);
    }

    return null;
}

function getSelectedSuppliersUuids() {
    let localStorageData = getLocalStorageData();
    let selectedSuppliersUuids = new Map();
    if (null !== localStorageData.selectionKeys) {
        selectedSuppliersUuids = new Map(
            Object.entries(localStorageData.selectionKeys)
        );
    }

    return selectedSuppliersUuids;
}

function setLocalStorageRowsPerPage(rowPerPage: number) {
    let storageData = localStorage.getItem(localStorageKey);
    if (null !== storageData) {
        let localStorageObject = JSON.parse(storageData);
        localStorageObject.rows = rowPerPage;
        localStorage.setItem(localStorageKey, JSON.stringify(localStorageObject));
    }
}

function getLocalStorageRowsPerPage() {
    let localStorageData = getLocalStorageData();
    if (null !== localStorageData && localStorageData.rows) {
        return localStorageData.rows;
    }

    return defaultRowsPerPage;
}

function getLocalStorageFisrtPageState() {
    let localStorageData = getLocalStorageData();
    if (null !== localStorageData && localStorageData.first) {
        return localStorageData.first;
    }

    return 0;
}

async function toggleSuppliersStatusByGroup(
    action: string,
    successMessage: string
) {
    let isActive = action === enableGroupAction;
    let selectedSuppliersUuids = getSelectedSuppliersUuids();
    const data = new Map();
    selectedSuppliersUuids.forEach((value, key) => {
        data.set(key, { uuid: key, isActive: isActive });
    });
    const mapDataIntoArray = Array.from(data.values());
    const dataToSendToApi = {
        suppliers: mapDataIntoArray,
    };

    showSpinner();
    await ApiService.patchWithoutSlug("suppliers", dataToSendToApi)
        .then(() => {
            swal.info(successMessage).then(() => {
                window.location.reload();
            });
        })
        .catch(() => {
            swal.error().then(() => {
                window.location.reload();
            });
        });
}

async function toggleOneSupplierStatus(
    action: string,
    uuid: string,
    successMessage: string
) {
    showSpinner();
    let isActive = action === enableOneAction;
    await ApiService.patchWithoutSlug("suppliers/" + uuid, { isActive: isActive })
        .then(() => {
            swal.info(successMessage).then(() => {
                window.location.reload();
            });
        })
        .catch(() => {
            swal.error();
        });
}

function checkSuppliersStatus(
    action: string,
    confirmMessage: string,
    successMessage: string,
    cancelButtonText?: string,
    confirmButtonText?: string,
    confirmButtonClass?: string,
    cancelButtonClass?: string,
    uuid?: string
) {
    swal
        .confirm(
            confirmMessage,
            cancelButtonText,
            confirmButtonText,
            confirmButtonClass,
            cancelButtonClass
        )
        .then((result) => {
            if (result.isConfirmed) {
                if ([enableGroupAction, disableGroupAction].includes(action)) {
                    toggleSuppliersStatusByGroup(action, successMessage);
                }
                if ([enableOneAction, disableOneAction].includes(action) && uuid) {
                    toggleOneSupplierStatus(action, uuid, successMessage);
                }
            } else {
                window.location.reload();
            }
        });
}

const supplierUuid = ref<string>("");

const setUuidAndOpenModal = (uuid: string) => {
    supplierUuid.value = uuid;
    const supplierFormModalElement:HTMLDialogElement | null = document.querySelector(`#${supplierFormModalId}`);
    if (supplierFormModalElement) {
        supplierFormModalElement.showModal();
    }
};

</script>